var _rect, _path, _path2, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOhm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.094,
    y: 7.094,
    width: 212.812,
    height: 212.812,
    rx: 106.406,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.56 63.787h99.88v99.88H63.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.396 163.44v.227h39.044v-14.074h-19.281c11.601-8.789 19.054-22.452 19.054-37.796 0-26.515-22.257-48.01-49.713-48.01s-49.713 21.495-49.713 48.01c0 15.344 7.453 29.007 19.054 37.796H63.56v14.074h39.043v-18.916c-14.226-4.478-24.516-17.488-24.516-32.84 0-19.056 15.855-34.504 35.412-34.504 19.558 0 35.412 15.448 35.412 34.504 0 15.352-10.29 28.362-24.516 32.84v18.689Z",
    fill: "#708B96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.094,
    y: 7.094,
    width: 212.812,
    height: 212.812,
    rx: 106.406,
    stroke: "url(#a)",
    strokeWidth: 14.188
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 113.5,
    y1: -119.175,
    x2: 113.5,
    y2: 363.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#708B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBE7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhm);
export default __webpack_public_path__ + "static/media/ohm.8821a8d8d6acf6222c966d5ee3c3b1f5.svg";
export { ForwardRef as ReactComponent };